<om-toast />
<router-outlet />
@if (showGlobalLoading()) {
<om-app-loading-screen />
}
